export default __webpack_public_path__ + "static/media/italian.7e786813.png";